import { defMathOp } from "./compile/emit.js";
export const [add, add2, add3, add4] = defMathOp("+");
